import * as actionTypes from 'store/actions/actionTypes'

export const download = (downloadType, folderName) => {
  return {
    type: actionTypes.DOWNLOAD,
    downloadType,
    folderName
  }
}
